/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable keyword-spacing */
import { store } from '../store';

import { userPermissionsSelector, userRoleSelector } from './user.selectors';
import { isLytRole, isLytAdminRole, isAdminRole } from '../../constants/roles.constants';
import { getUserInAgencyId, getLytHqId } from '../../services/requests/request.utils';

export const getUserRole = () => userRoleSelector(store.getState());

export const isLYTAdmin = () => isLytAdminRole(getUserRole());

export const isAdmin = () => isAdminRole(getUserRole());

/** Returns true when the current user has an LYT-internal role (lyt_admin or lyt_employee). */
export const isLYTRole = () => isLytRole(getUserRole());

export const isLYTAdminInLYTAgency = () => {
    // tmp solution, as BE doesn`t know which agency is the main
    if (isLYTAdmin() && getUserInAgencyId() === getLytHqId()) {
        return true;
    }

    return false;
};
export const checkPermissionByName = (name = '') => {
    const permissionsList = userPermissionsSelector(store.getState());

    if (name in permissionsList) {
        return permissionsList[name];
    } else {
        console.error('wrong permission name');
    }
};

// format US phone number
export const formatPhoneNumber = phoneNumberString => {
    if (phoneNumberString === '**********') {
        return '*** ***-****';
    }
    var cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        var intlCode = match[1] ? '+1 ' : '';
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
};
